import { render, staticRenderFns } from "./TopSongs.vue?vue&type=template&id=63e9eb58&scoped=true"
import script from "./TopSongs.vue?vue&type=script&lang=js"
export * from "./TopSongs.vue?vue&type=script&lang=js"
import style0 from "./TopSongs.vue?vue&type=style&index=0&id=63e9eb58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e9eb58",
  null
  
)

export default component.exports